module.exports = __webpack_public_path__ + "img/incident_medico.f29018ab.svg";